import AgendarPagina from './AgendarPagina';

export default AgendarPagina;